var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('router-view')],1),_c('changelog-modal',{attrs:{"is-show":_vm.visible,"changelog-data":_vm.changelog},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }